import React, { ReactNode } from 'react'
import { useIntl } from 'react-intl'

import dayjs from 'dayjs'

import { bemJoin } from '@app/lib/bem'
import { IMessage, MessageType, MessageTypeTitle } from '@app/lib/components/ModernChat'
import { Text } from '@app/lib/typography/Text/Text'

import './ModernChatHeader.scss'

export type ModernChatHeaderProps = {
  badges?: ReactNode
  message: Partial<IMessage>
}

export const ModernChatHeader = ({ message, badges }: ModernChatHeaderProps) => {
  const b = bemJoin('modern-chat-header')
  const { formatMessage } = useIntl()

  const isQuestion = message.type === MessageType.Question
  const type = message.type ? MessageTypeTitle[message.type] : undefined

  const label =
    isQuestion && message.topic?.name
      ? formatMessage({ id: 'ModernChatHeader.Topic' }, { topic: message.topic.name })
      : type

  return (
    <div className={b({ answer: !isQuestion })}>
      <div className={b('title')}>
        {label && (
          <Text weight={'bold'} className={b('label')}>
            {label}
          </Text>
        )}
        {message.updatedAt && (
          <Text color={'neutral'} className={b('updated-at')}>
            {dayjs(message.updatedAt).format('DD.MM.YYYY')}
          </Text>
        )}
      </div>
      {badges && <div className={b('badges')}>{badges}</div>}
    </div>
  )
}
